// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #e3f2fd !important;
}

#root {
  background-color: #e3f2fd !important;
  min-height: 100vh;
}

* {
  box-sizing: border-box;
}

/* Navigation consistency across all devices */
nav {
  padding: 8px 0 !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

@media (max-width: 768px) {
  .home-root {
    min-height: 100vh;
    background-color: #e3f2fd;
  }
  .home-container {
    max-width: 100%;
    padding: 16px 4px;
  }
  .home-main-column {
    gap: 16px;
  }
  .home-announcement-box {
    max-width: 100%;
    padding: 16px;
  }
  .home-announcement-header h3 {
    font-size: 20px;
  }
  .home-announcement-header .icon {
    width: 36px;
    height: 36px;
    font-size: 18px;
    margin-right: 8px;
  }
  .home-banner-below {
    max-width: 100% !important;
    margin: 0 auto !important;
  }
  .home-announcement-box p {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .yearhome-root {
    max-width: 100%;
    padding: 0 4px 12px 4px;
    min-height: 100vh;
  }
  .yearhome-header h1 {
    font-size: 2rem;
  }
  .yearhome-groups-row {
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }
  .yearhome-group-card {
    min-width: 0;
    width: 100%;
    padding: 18px 8px;
  }
  .yearhome-group-card h3 {
    font-size: 1.1rem;
  }
  .yearhome-group-card .icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
    margin-bottom: 8px;
  }
}

/* Additional mobile styles for all pages */
@media (max-width: 768px) {
  /* Make tables responsive */
  table {
    font-size: 12px;
    overflow-x: auto;
    display: block;
    white-space: nowrap;
  }
  
  /* Make buttons mobile-friendly */
  button {
    min-height: 44px;
    padding: 8px 16px;
  }
  
  /* Responsive text */
  h1 {
    font-size: 1.8rem !important;
  }
  
  h2 {
    font-size: 1.5rem !important;
  }
  
  h3 {
    font-size: 1.3rem !important;
  }
  
  /* Responsive containers */
  .container, .content {
    padding: 8px 12px !important;
    margin: 0 !important;
    max-width: 100% !important;
  }
  
  /* Make images responsive */
  img {
    max-width: 100% !important;
    height: auto !important;
  }
  
  /* Hide desktop-only elements */
  .desktop-only {
    display: none !important;
  }
  
  /* Show mobile-only elements */
  .mobile-only {
    display: block !important;
  }
}

/* Modern Design System Tokens & Utility Classes */
.modern-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .modern-container {
    padding: 16px 12px;
  }
}

.modern-page-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(226, 232, 240, 0.8);
  padding: 32px;
  margin-bottom: 32px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .modern-page-card {
    padding: 20px 16px;
    border-radius: 12px;
    margin-bottom: 20px;
  }
}

.modern-section-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #edf2f7;
  margin-bottom: 24px;
  box-sizing: border-box;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.02);
}

@media (max-width: 768px) {
  .modern-section-card {
    padding: 16px;
    border-radius: 10px;
    margin-bottom: 16px;
  }
}

/* Modern Scoreboard Badge */
.scoreboard-wrapper {
  background: linear-gradient(135deg, #f8fafc 0%, #edf2f7 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.02);
}

@media (max-width: 768px) {
  .scoreboard-wrapper {
    padding: 16px;
    border-radius: 12px;
    margin-bottom: 20px;
  }
}

/* Schedule match cards: keep scores aligned when logos differ in size */
.schedule-match-row {
  align-items: stretch !important;
}

.schedule-team-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.schedule-team-logo-slot {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  flex-shrink: 0;
}

.schedule-team-logo-slot img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  background-color: #e3f2fd;
}

.schedule-team-name {
  min-height: 2.4em;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.schedule-team-score {
  margin-top: auto;
  line-height: 1;
}

.schedule-vs {
  align-self: center;
}

/* Modern Tables styling */
.modern-table-wrapper {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  background: #ffffff;
  margin: 12px 0 24px 0;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  font-family: inherit;
}

.modern-table th {
  background: #f8fafc;
  color: #475569;
  font-weight: 700;
  text-align: center;
  padding: 14px 12px;
  border-bottom: 2px solid #e2e8f0;
  font-size: 13px;
  white-space: nowrap;
}

.modern-table td {
  padding: 12px 12px;
  border-bottom: 1px solid #edf2f7;
  color: #334155;
  text-align: center;
  font-size: 13px;
}

.modern-table tr {
  transition: background-color 0.15s ease;
}

.modern-table tr:hover {
  background-color: #f1f5f9 !important;
}

.modern-table tr:nth-child(even) {
  background-color: #f8fafc;
}

.modern-table tr:nth-child(odd) {
  background-color: #ffffff;
}

/* Specific alignments for tables */
.modern-table th.align-left,
.modern-table td.align-left {
  text-align: left;
}

/* Highlight important stats columns */
.modern-table td.highlight-stat,
.modern-table th.highlight-stat {
  font-weight: 700;
  color: #0f172a;
}

.modern-table td.total-stat {
  font-weight: 800;
  background-color: #f8fafc;
}

/* Compact boxscore: fit EFF without horizontal scroll */
.boxscore-table {
  table-layout: fixed;
  width: 100%;
  min-width: 0;
}

.boxscore-table th,
.boxscore-table td {
  padding: 10px 4px;
  font-size: 12px;
}

.boxscore-table th.boxscore-name,
.boxscore-table td.boxscore-name {
  width: 5.5em;
  max-width: 5.5em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 8px;
  padding-right: 4px;
}

.boxscore-table th.boxscore-jersey,
.boxscore-table td.boxscore-jersey {
  width: 28px;
  padding-left: 6px;
  padding-right: 2px;
}

/* Premium links */
.modern-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.15s ease, text-decoration-color 0.15s ease;
}

.modern-link:hover {
  color: #115293;
  text-decoration: underline;
}

/* Section Title styling */
.modern-section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 16px;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modern-section-title a {
  text-decoration: none;
  color: inherit;
  transition: color 0.2s ease;
}

.modern-section-title a:hover {
  color: #1976d2;
}

/* Custom interactive video quarter buttons */
.video-tab-btn {
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: auto !important; /* Override generic button padding on mobile if needed */
}

.video-tab-btn:hover:not(:disabled) {
  background: #f1f5f9;
  color: #1e293b;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.video-tab-btn.active {
  background: #1976d2;
  color: #ffffff;
  border-color: #1976d2;
  box-shadow: 0 4px 6px -1px rgba(25, 118, 210, 0.2);
}

.video-tab-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: #f8fafc;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;EACE;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,0BAA0B;EAC1B;IACE,4BAA4B;IAC5B,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA,2BAA2B;EAC3B;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA,+BAA+B;EAC/B;IACE,wBAAwB;EAC1B;;EAEA,8BAA8B;EAC9B;IACE,yBAAyB;EAC3B;AACF;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qFAAqF;EACrF,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,kFAAkF;AACpF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA,wEAAwE;AACxE;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kFAAkF;EAClF,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;;EAEE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,8DAA8D;AAChE;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,2BAA2B,EAAE,wDAAwD;AACvF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #e3f2fd !important;\n}\n\n#root {\n  background-color: #e3f2fd !important;\n  min-height: 100vh;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* Navigation consistency across all devices */\nnav {\n  padding: 8px 0 !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@media (max-width: 768px) {\n  .home-root {\n    min-height: 100vh;\n    background-color: #e3f2fd;\n  }\n  .home-container {\n    max-width: 100%;\n    padding: 16px 4px;\n  }\n  .home-main-column {\n    gap: 16px;\n  }\n  .home-announcement-box {\n    max-width: 100%;\n    padding: 16px;\n  }\n  .home-announcement-header h3 {\n    font-size: 20px;\n  }\n  .home-announcement-header .icon {\n    width: 36px;\n    height: 36px;\n    font-size: 18px;\n    margin-right: 8px;\n  }\n  .home-banner-below {\n    max-width: 100% !important;\n    margin: 0 auto !important;\n  }\n  .home-announcement-box p {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .yearhome-root {\n    max-width: 100%;\n    padding: 0 4px 12px 4px;\n    min-height: 100vh;\n  }\n  .yearhome-header h1 {\n    font-size: 2rem;\n  }\n  .yearhome-groups-row {\n    flex-direction: column;\n    gap: 16px;\n    align-items: center;\n  }\n  .yearhome-group-card {\n    min-width: 0;\n    width: 100%;\n    padding: 18px 8px;\n  }\n  .yearhome-group-card h3 {\n    font-size: 1.1rem;\n  }\n  .yearhome-group-card .icon {\n    width: 40px;\n    height: 40px;\n    font-size: 18px;\n    margin-bottom: 8px;\n  }\n}\n\n/* Additional mobile styles for all pages */\n@media (max-width: 768px) {\n  /* Make tables responsive */\n  table {\n    font-size: 12px;\n    overflow-x: auto;\n    display: block;\n    white-space: nowrap;\n  }\n  \n  /* Make buttons mobile-friendly */\n  button {\n    min-height: 44px;\n    padding: 8px 16px;\n  }\n  \n  /* Responsive text */\n  h1 {\n    font-size: 1.8rem !important;\n  }\n  \n  h2 {\n    font-size: 1.5rem !important;\n  }\n  \n  h3 {\n    font-size: 1.3rem !important;\n  }\n  \n  /* Responsive containers */\n  .container, .content {\n    padding: 8px 12px !important;\n    margin: 0 !important;\n    max-width: 100% !important;\n  }\n  \n  /* Make images responsive */\n  img {\n    max-width: 100% !important;\n    height: auto !important;\n  }\n  \n  /* Hide desktop-only elements */\n  .desktop-only {\n    display: none !important;\n  }\n  \n  /* Show mobile-only elements */\n  .mobile-only {\n    display: block !important;\n  }\n}\n\n/* Modern Design System Tokens & Utility Classes */\n.modern-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .modern-container {\n    padding: 16px 12px;\n  }\n}\n\n.modern-page-card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  padding: 32px;\n  margin-bottom: 32px;\n  box-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n  .modern-page-card {\n    padding: 20px 16px;\n    border-radius: 12px;\n    margin-bottom: 20px;\n  }\n}\n\n.modern-section-card {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 24px;\n  border: 1px solid #edf2f7;\n  margin-bottom: 24px;\n  box-sizing: border-box;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.02);\n}\n\n@media (max-width: 768px) {\n  .modern-section-card {\n    padding: 16px;\n    border-radius: 10px;\n    margin-bottom: 16px;\n  }\n}\n\n/* Modern Scoreboard Badge */\n.scoreboard-wrapper {\n  background: linear-gradient(135deg, #f8fafc 0%, #edf2f7 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 32px;\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.02);\n}\n\n@media (max-width: 768px) {\n  .scoreboard-wrapper {\n    padding: 16px;\n    border-radius: 12px;\n    margin-bottom: 20px;\n  }\n}\n\n/* Schedule match cards: keep scores aligned when logos differ in size */\n.schedule-match-row {\n  align-items: stretch !important;\n}\n\n.schedule-team-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.schedule-team-logo-slot {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n  flex-shrink: 0;\n}\n\n.schedule-team-logo-slot img {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  border-radius: 8px;\n  background-color: #e3f2fd;\n}\n\n.schedule-team-name {\n  min-height: 2.4em;\n  line-height: 1.2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.schedule-team-score {\n  margin-top: auto;\n  line-height: 1;\n}\n\n.schedule-vs {\n  align-self: center;\n}\n\n/* Modern Tables styling */\n.modern-table-wrapper {\n  overflow-x: auto;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n  background: #ffffff;\n  margin: 12px 0 24px 0;\n}\n\n.modern-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #ffffff;\n  font-family: inherit;\n}\n\n.modern-table th {\n  background: #f8fafc;\n  color: #475569;\n  font-weight: 700;\n  text-align: center;\n  padding: 14px 12px;\n  border-bottom: 2px solid #e2e8f0;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.modern-table td {\n  padding: 12px 12px;\n  border-bottom: 1px solid #edf2f7;\n  color: #334155;\n  text-align: center;\n  font-size: 13px;\n}\n\n.modern-table tr {\n  transition: background-color 0.15s ease;\n}\n\n.modern-table tr:hover {\n  background-color: #f1f5f9 !important;\n}\n\n.modern-table tr:nth-child(even) {\n  background-color: #f8fafc;\n}\n\n.modern-table tr:nth-child(odd) {\n  background-color: #ffffff;\n}\n\n/* Specific alignments for tables */\n.modern-table th.align-left,\n.modern-table td.align-left {\n  text-align: left;\n}\n\n/* Highlight important stats columns */\n.modern-table td.highlight-stat,\n.modern-table th.highlight-stat {\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.modern-table td.total-stat {\n  font-weight: 800;\n  background-color: #f8fafc;\n}\n\n/* Compact boxscore: fit EFF without horizontal scroll */\n.boxscore-table {\n  table-layout: fixed;\n  width: 100%;\n  min-width: 0;\n}\n\n.boxscore-table th,\n.boxscore-table td {\n  padding: 10px 4px;\n  font-size: 12px;\n}\n\n.boxscore-table th.boxscore-name,\n.boxscore-table td.boxscore-name {\n  width: 5.5em;\n  max-width: 5.5em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 8px;\n  padding-right: 4px;\n}\n\n.boxscore-table th.boxscore-jersey,\n.boxscore-table td.boxscore-jersey {\n  width: 28px;\n  padding-left: 6px;\n  padding-right: 2px;\n}\n\n/* Premium links */\n.modern-link {\n  color: #1976d2;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.15s ease, text-decoration-color 0.15s ease;\n}\n\n.modern-link:hover {\n  color: #115293;\n  text-decoration: underline;\n}\n\n/* Section Title styling */\n.modern-section-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 16px;\n  border-bottom: 2px solid #edf2f7;\n  padding-bottom: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.modern-section-title a {\n  text-decoration: none;\n  color: inherit;\n  transition: color 0.2s ease;\n}\n\n.modern-section-title a:hover {\n  color: #1976d2;\n}\n\n/* Custom interactive video quarter buttons */\n.video-tab-btn {\n  padding: 8px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #475569;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-height: auto !important; /* Override generic button padding on mobile if needed */\n}\n\n.video-tab-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #1e293b;\n  border-color: #cbd5e1;\n  transform: translateY(-1px);\n}\n\n.video-tab-btn.active {\n  background: #1976d2;\n  color: #ffffff;\n  border-color: #1976d2;\n  box-shadow: 0 4px 6px -1px rgba(25, 118, 210, 0.2);\n}\n\n.video-tab-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  background: #f8fafc;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
